import { track } from './amplitude';
import { POI_VIEWED } from './events';
import { userSelectedSight, $sceneId, setSceneId } from '../state/appState';
import type { SightId } from '../types';

/**
 * Tracks user-initiated POI selections (chip click, suggestion click,
 * focus-sight action, etc.). Authoritative "visited" state is owned by
 * the backend via `tour` items on assistant_message — see
 * `progressTracker.ts` for `Scene POI Visited` / `Scene Completed` /
 * `Next Scene Hinted` events derived from that source of truth.
 */

let viewedInScene = new Set<SightId>();

export const startTourTracking = () => {
  setSceneId.watch(() => {
    viewedInScene = new Set();
  });

  userSelectedSight.watch(({ id, source }) => {
    const sceneId = $sceneId.getState();
    const isFirstView = !viewedInScene.has(id);
    viewedInScene.add(id);

    track(POI_VIEWED, {
      sight_id: id,
      scene_id: sceneId,
      source: source ?? 'unknown',
      is_first_view: isFirstView,
    });
  });
};
